/**
 * "Claude is writing" chips: the presence of connected assistants on the
 * document the user is looking at. Colors come from the assistant's own
 * awareness state (the same values its editor caret uses), so the chip and
 * the caret always match.
 */
import type { CSSProperties } from "react";
import type { AgentPresence } from "@/data/presence";
import s from "./PresenceChips.module.css";

export function PresenceChips({
  present,
  verb = "is here",
  writingVerb = "is writing",
  compact = false,
}: {
  present: AgentPresence[];
  verb?: string;
  writingVerb?: string;
  compact?: boolean;
}) {
  if (present.length === 0) return null;
  return (
    <span className={[s.row, compact ? s.compact : ""].join(" ")} role="status" aria-live="polite" data-presence-chips>
      {present.map((p) => (
        <span
          key={p.clientId}
          className={[s.chip, p.writing ? s.writing : ""].join(" ")}
          style={{ "--chip": p.color, "--chip-bg": p.colorLight } as CSSProperties}
          title={`${p.name} ${p.writing ? writingVerb : verb}`}
        >
          <span className={s.dot} aria-hidden />
          <span className={s.name}>{p.name}</span>
          {!compact ? <span className={s.verb}>{p.writing ? writingVerb : verb}</span> : null}
        </span>
      ))}
    </span>
  );
}
